import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as businessPaymentRunEmployeesByProductState from '../reducers';
import * as businessPaymentRunEmployeesByProductReducer from '../reducers/business-payment-run-detail-employees-by-product.reducer';

export const selectBusinessPaymentRunEmployeesByProduct = createSelector(
  businessPaymentRunEmployeesByProductState.selectBusinessPaymentRunDetailEmployeesByProductState,
  businessPaymentRunEmployeesByProductReducer.getBusinessPaymentRunDetailEmployeesByProduct
);
